export const setTitleByOriginatorRole = originatorRole => {
  switch(originatorRole) {
    case 'BOT':
    case 'SYSTEM': {
      return 'Bot'
    }
    case 'USER': {
      return 'Agent'
    }
    case 'MODERATOR': {
      return 'Agent (external)'
    }
    case 'EXTERNAL': {
      return 'Customer'
    }
    default: {
      return originatorRole
    }
  }
}

export const setTitleByChannelName = channelName => {
  switch(channelName) {
    case 'all': {
      return 'All Channels'
    }
    case 'apple': {
      return 'Apple Business Chat'
    }
    case 'rbm': {
      return 'Google RBM'
    }
    
    case 'messenger':
    case 'facebook': {
      return 'Facebook'
    }

    case 'rocketchat': {
      return 'RocketChat'
    }

    case 'liveperson': {
      return 'LivePerson'
    }

    case 'khoros': {
      return 'Khoros'
    }

    case 'mavenir': {
      return 'Mavenir'
    }

    case 'telegram': {
      return 'Telegram'
    }

    case 'twilio': {
      return 'Twilio'
    }

    case 'twitter': {
      return 'Twitter'
    }

    case 'slack': {
      return 'Slack'
    }

    case 'messagemedia': {
      return 'MessageMedia'
    }

    case 'viber': {
      return 'Viber'
    }

    case 'sparkcentral': {
      return 'Sparkcentral'
    }

    case 'wit': {
      return 'Wit'
    }
    
    case 'front': {
      return 'Front'
    }

    case 'rest': {
      return 'Rest'
    }

    case 'kik': {
      return 'Kik'
    }

    case 'socket_sdk': {
      return 'SDK'
    }

    case 'socket': {
      return 'Web & Socket API'
    }

    case 'socketsdk': {
      return 'Socket SDK'
    }

    case 'alexa': {
      return 'Alexa'
    }

    case 'whatsapptest':
    case 'whatsapp360':
    case 'whatsapp360v2':
    case 'whatsapp': {
      return 'WhatsApp'
    }

    default: {
      return channelName
    }
  }
}

export const setTitleByDimension = (dimensionValue, dimensions) => {
  let title = dimensionValue
  for (let i = 0; i < dimensions.length; i++) {
    const dimension = dimensions[i]
    switch(dimension) {
      case 'channelname': {
        title = setTitleByChannelName(dimensionValue)
        break
      }
      case 'eventname': {
        title = setTitleByEventName(dimensionValue)
        break
      }
      case 'originatorrole':{
        title = setTitleByOriginatorRole(dimensionValue)
        break
      }
    }

    if(title !== dimensionValue) {
      break
    }
  }

  return title
}

export const setTitleByEventName = eventName => {
  switch (eventName) {
    case 'USER_NEW': {
      return 'New users'
    }
    case 'USER_OLD': {
      return 'Existing users'
    }

    default: {
      return eventName
    }
  }
}